<template>
  <div>
    <DxForm
      id="irrigationForm"
      caption="Irrigation Form"
    >
      <DxGroupItem
        :caption="$t('DxIrrigation_DxGroupItem_irrigationWater_caption')"
        :col-count="4"
      >
        <DxSimpleItem
          :data-field="$t('DxIrrigation_DxColumn_availableVolume_caption')"
          name="availableVolume"
          :caption="$t(' DxIrrigation_DxColumn_availableVolume_caption')"
          css-class="element-width-min-width"
          :editor-options="{
            value: availableVolume,
            showSpinButtons: true,
            placeholder: $t('Dx_AvailableVolume_Placeholder'),
            showClearButton: true,
            min: '0',
            max: 100000000,
            step: '1',
            onValueChanged: availableVolumeValueChanged,
          }"
          editor-type="dxNumberBox"
        />
        <DxSimpleItem
          data-field=""
          css-class="icon-info-right"
          template="default"
        >
          <template #default>
            <div>
              <DxButton
                name="info"
                css-class="icon-info-right"
                icon="info"
                :hint="$t('AvaliableWater_Info')"
              />
            </div>
          </template>
        </DxSimpleItem>
        <DxSimpleItem
          :data-field="$t('DxIrrigation_DxColumn_irrigationWaterCost_caption')"
          name="irrigationWaterCost"
          :caption="$t('DxIrrigation_DxColumn_irrigationWaterCost_caption')"
          css-class="element-width-min-width"
          :editor-options="{
            value: irrigationWaterCost,
            showSpinButtons: true,
            placeholder: $t('Dx_IrrigationWaterCost_Placeholder'),
            showClearButton: true,
            min: '0',
            max: 100,
            step: '1',
            onValueChanged: irrigationWaterCostValueChanged,
          }"

          editor-type="dxNumberBox"
        />
        <DxSimpleItem
          data-field=""
          template="default"
          css-class="icon-info-right"
        >
          <template #default>
            <div>
              <DxButton
                name="info"
                icon="info"
                :hint="$t('IrrigationWaterCost_Info')"
              />
            </div>
          </template>
        </DxSimpleItem>
      </DxGroupItem>
      <DxGroupItem
        :caption="$t('DxIrrigation_DxGroupItem_irrigationSystem_caption')"
      >
        <DxGroupItem
          :col-count="4"
        >
          <DxSimpleItem
            :data-field="$t('DxIrrigation_DxColumn_maximumIrrigation_caption')"
            name="maximumIrrigation"
            :caption="$t('DxIrrigation_DxColumn_maximumIrrigation_caption')"
            css-class="element-width-min-width"
            :editor-options="{
              value: maximumIrrigation,
              showSpinButtons: true,
              placeholder: $t('Dx_MaximumIrrigation_Placeholder'),
              showClearButton: true,
              min: minimumIrrigation ? minimumIrrigation : '1',
              max: 30,
              step: '1',
              onValueChanged: maximumIrrigationValueChanged,
            }"
            editor-type="dxNumberBox"
          />
          <DxSimpleItem
            data-field=""
            template="default"
            css-class="icon-info-right"
          >
            <template #default>
              <div>
                <DxButton
                  name="info"
                  icon="info"
                  :hint="$t('MaximumIrrigation_Info')"
                />
              </div>
            </template>
          </Dxsimpleitem>
          <DxSimpleItem
            :data-field="$t('DxIrrigation_DxColumn_minimumIrrigation_caption')"
            name="minimumIrrigation"
            :caption="$t('DxIrrigation_DxColumn_minimumIrrigation_caption')"
            css-class="element-width-min-width"
            :editor-options="{
              value: minimumIrrigation,
              showSpinButtons: true,
              placeholder: $t('Dx_MinimumIrrigation_Placeholder'),
              showClearButton: true,
              min: '1',
              max: maximumIrrigation < 30 ? maximumIrrigation : 30,
              step: '1',
              onValueChanged: minimumIrrigationValueChanged,
            }"
            editor-type="dxNumberBox"
          />
          <DxSimpleItem
            data-field=""
            template="default"
            css-class="icon-info-right"
          >
            <template #default>
              <div>
                <DxButton
                  name="info"
                  icon="info"
                  :hint="$t('MinimumIrrigation_Info')"
                />
              </div>
            </template>
          </Dxsimpleitem>
        </DxGroupItem>
        <DxGroupItem
          :col-count="4"
        >
          <DxSimpleItem
            :data-field="$t('DxIrrigation_DxColumn_maximumIrrigationDose_caption')"
            name="maximumIrrigationDose"
            :caption="$t('DxIrrigation_DxColumn_maximumIrrigationDose_caption')"
            css-class="element-width-min-width"
            :editor-options="{
              value: maximumIrrigationDose,
              showSpinButtons: true,
              placeholder: $t('Dx_MaximumIrrigationDose_Placeholder'),
              showClearButton: true,
              min: minimumIrrigationDose ? minimumIrrigationDose: '1',
              max:100000000,
              step: '1',
              onValueChanged: maximumIrrigationDoseValueChanged,
            }"
            editor-type="dxNumberBox"
          />
          <DxSimpleItem
            data-field=""
            template="default"
            css-class="icon-info-right"
          >
            <template #default>
              <div>
                <DxButton
                  name="info"
                  icon="info"
                  :hint="$t('MaximumIrrigationDose_Info')"
                />
              </div>
            </template>
          </Dxsimpleitem>
          <DxSimpleItem
            :data-field="$t('DxIrrigation_DxColumn_minimumIrrigationDose_caption')"
            name="minimumIrrigationDose"
            :caption="$t('DxIrrigation_DxColumn_minimumIrrigationDose_caption')"
            css-class="element-width-min-width"
            :editor-options="{
              value: minimumIrrigationDose,
              showSpinButtons: true,
              placeholder: $t('Dx_MinimumIrrigationDose_Placeholder'),
              showClearButton: true,
              min: '1',
              max: maximumIrrigationDose < 50 ? maximumIrrigationDose : 50,
              step: '1',
              onValueChanged: minimumIrrigationDoseValueChanged,
            }"
            editor-type="dxNumberBox"
          />
          <DxSimpleItem
            data-field=""
            template="default"
            css-class="icon-info-right"
          >
            <template #default>
              <div>
                <DxButton
                  name="info"
                  icon="info"
                  :hint="$t('MinimumIrrigationDose_Info')"
                />
              </div>
            </template>
          </Dxsimpleitem>
          <DxSimpleItem
            :data-field="$t('DxIrrigation_DxColumn_efficiency_caption')"
            name="efficiency"
            :caption="$t('DxIrrigation_DxColumn_efficiency_caption')"
            css-class="element-min-width"
            :editor-options="{
              value: efficiency,
              showSpinButtons: true,
              placeholder: $t('Dx_Efficiency_Placeholder'),
              showClearButton: true,
              min: '0',
              step: '1',
              max: 100,
              onValueChanged: efficiencyValueChanged,
            }"
            editor-type="dxNumberBox"
          />
          <DxSimpleItem
            data-field=""
            template="default"
            css-class="icon-info-right"
          >
            <template #default>
              <div>
                <DxButton
                  name="info"
                  icon="info"
                  :hint="$t('Efficiency_Info')"
                />
              </div>
            </template>
          </Dxsimpleitem>
        </DxGroupItem>
      </DxGroupItem>
    </DxForm>
    <f7-block-title>
      {{ $t('DxIrrigation_DxColumn_advancedIrrigationSettings_caption') }}
    </f7-block-title>
    <f7-list
      accordion-list
      accordion-opposite
    >
      <f7-list-item
        accordion-item
      >
        <f7-accordion-content>
          <DxForm
            id="irrigationFormAdvance"
            caption="Irrigation Form Advance"
          >
            <DxGroupItem>
              <DxGroupItem
                :col-count="4"
              >
                <DxSimpleItem
                  :data-field="$t('DxIrrigation_DxColumn_suboptimizationModel_caption')"
                  css-class="element-min-width"
                  :editor-options="{
                    items: suboptimizationModelOptions,
                    searchEnabled: true,
                    searchTimeout: searchTimeoutOption,
                    minSearchLength: minSearchLengthOption,
                    showDataBeforeSearch: showDataBeforeSearchOption,
                    onValueChanged: suboptimizationModelValueChanged,
                    value: suboptimizationModel,
                  }"
                  editor-type="dxSelectBox"
                  name="floorSelector"
                >
                  <DxRequiredRule :message="$t('DxPlanningForm_activity_name')" />
                </DxSimpleItem>
                <DxSimpleItem
                  data-field=""
                  template="default"
                  css-class="icon-info-right"
                >
                  <template #default>
                    <div>
                      <DxButton
                        name="info"
                        icon="info"
                        :hint="$t('SuboptimizationModel_Info')"
                      />
                    </div>
                  </template>
                </DxSimpleItem>
                <DxSimpleItem
                  :data-field="$t('DxIrrigation_DxColumn_numberOfPointsInTheFunction_caption')"
                  name="numberOfPointsInTheFunction"
                  :caption="$t('DxIrrigation_DxColumn_numberOfPointsInTheFunction_caption')"
                  css-class="element-min-width"
                  :editor-options="{
                    value: numberOfPointsInTheFunction,
                    showSpinButtons: true,
                    placeholder: $t('Dx_NumberOfPointsInTheFunction_Placeholder'),
                    showClearButton: true,
                    min: '0.01',
                    max:0.5,
                    step: '0.01',
                    onValueChanged: numberOfPointsInTheFunctionValueChanged,
                  }"
                  editor-type="dxNumberBox"
                />
                <DxSimpleItem
                  data-field=""
                  template="default"
                  css-class="icon-info-right"
                >
                  <template #default>
                    <div>
                      <DxButton
                        name="info"
                        icon="info"
                        :hint="$t('NumberOfPointsInTheFunction_Info')"
                      />
                    </div>
                  </template>
                </DxSimpleItem>
                <DxSimpleItem
                  :data-field="$t('DxIrrigation_DxColumn_initialSoilMoisture_caption')"
                  name="initialSoilMoisture"
                  :caption="$t('DxIrrigation_DxColumn_initialSoilMoisture_caption')"
                  css-class="element-min-width"
                  :editor-options="{
                    value: initialSoilMoisture,
                    showSpinButtons: true,
                    placeholder: $t('Dx_InitialSoilMoisture_Placeholder'),
                    showClearButton: true,
                    min: '1',
                    max: 100,
                    step: '1',
                    onValueChanged: initialSoilMoistureValueChanged,
                  }"
                  editor-type="dxNumberBox"
                />
                <DxSimpleItem
                  data-field=""
                  template="default"
                  css-class="icon-info-right"
                >
                  <template #default>
                    <div>
                      <DxButton
                        name="info"
                        icon="info"
                        :hint="$t('InitialSoilMoisture_Info')"
                      />
                    </div>
                  </template>
                </DxSimpleItem>
                <DxSimpleItem
                  :data-field="$t('DxIrrigation_DxColumn_soilWaterFillLevel_caption')"
                  name="soilWaterFillLevel"
                  :caption="$t('DxIrrigation_DxColumn_soilWaterFillLevel_caption')"
                  css-class="element-min-width"
                  :editor-options="{
                    value: soilWaterFillLevel,
                    showSpinButtons: true,
                    placeholder: $t('Dx_SoilWaterFillLevel_Placeholder'),
                    showClearButton: true,
                    min: '0',
                    max: 100,
                    step: '1',
                    onValueChanged: soilWaterFillLevelValueChanged,
                  }"
                  editor-type="dxNumberBox"
                />
                <DxSimpleItem
                  data-field=""
                  template="default"
                  css-class="icon-info-right"
                >
                  <template #default>
                    <div>
                      <DxButton
                        name="info"
                        icon="info"
                        :hint="$t('SoilWaterFillLevel_Info')"
                      />
                    </div>
                  </template>
                </DxSimpleItem>
                <DxSimpleItem
                  :data-field="$t('DxIrrigation_DxColumn_soilWaterDepletionLevel_caption')"
                  name="soilWaterDepletionLevel"
                  :caption="$t('DxIrrigation_DxColumn_soilWaterDepletionLevel_caption')"
                  css-class="element-min-width"
                  :editor-options="{
                    value: soilWaterDepletionLevel,
                    showSpinButtons: true,
                    placeholder: $t('Dx_SoilWaterDepletionLevel_Placeholder'),
                    showClearButton: true,
                    min: '0',
                    max: 100,
                    step: '1',
                    onValueChanged: soilWaterDepletionLevelValueChanged,
                  }"
                  editor-type="dxNumberBox"
                />
                <DxSimpleItem
                  data-field=""
                  template="default"
                  css-class="icon-info-right"
                >
                  <template #default>
                    <div>
                      <DxButton
                        name="info"
                        icon="info"
                        :hint="$t('SoilWaterDepletionLevel_Info')"
                      />
                    </div>
                  </template>
                </DxSimpleItem>
              </DxGroupItem>
            </DxGroupItem>
          </DxForm>
        </f7-accordion-content>
      </f7-list-item>
    </f7-list>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxRequiredRule,
} from 'devextreme-vue/form';
import DxButton from 'devextreme-vue/button';

export default {
  name: 'DxIrrigation',
  components: {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxRequiredRule,
    DxButton,
  },
  props: {
    defaultIrrigationValues: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      availableVolume: null,
      irrigationWaterCost: null,
      maximumIrrigation: null,
      minimumIrrigation: null,
      maximumIrrigationDose: null,
      minimumIrrigationDose: null,
      efficiency: null,
      irrigationSystem: '',
      suboptimizationModel: '',
      numberOfPointsInTheFunction: null,
      numberOfSubplots: null,
      initialSoilMoisture: null,
      soilWaterFillLevel: null,
      soilWaterDepletionLevel: null,
      searchTimeoutOption: 200,
      minSearchLengthOption: 0,
      showDataBeforeSearchOption: false,
    };
  },
  computed: {
    ...mapState('Mopeco', ['currentAvailableVolume', 'currentIrrigationWaterCost', 'currentMaximumIrrigation', 'currentMinimumIrrigation', 'currentMaximumIrrigationDose',
      'currentMinimumIrrigationDose', 'currentEfficiency', 'suboptimizationModelOptions',
      'currentNumberOfPointsInTheFunction', 'currentInitialSoilMoisture', 'currentSoilWaterFillLevel', 'currentSoilWaterDepletionLevel', 'currentSuboptimizationModel']),
  },
  beforeMount() {
    if (this.currentSuboptimizationModel === '' || this.currentSuboptimizationModel === null) {
      let optimizationSubmodel;
      switch (this.defaultIrrigationValues.optimizationSubmodel) {
        case 'OptSubmodelP':
          optimizationSubmodel = 'Riego/Rendimiento';
          break;
        case 'OptSubmodelPPef':
          optimizationSubmodel = 'Riego/Rendimiento/Precipitación';
          break;
        default:
          optimizationSubmodel = 'Riego/Rendimiento/Precipitación/Superficie';
          break;
      }
      this.setCurrentSuboptimizationModel(optimizationSubmodel);
    }

    if (this.currentNumberOfPointsInTheFunction === '' || this.currentNumberOfPointsInTheFunction === null) {
      this.setCurrentNumberOfPointsInTheFunction(this.defaultIrrigationValues.curveResolution);
    }

    if (this.currentInitialSoilMoisture === '' || this.currentInitialSoilMoisture === null) {
      this.setCurrentInitialSoilMoisture(this.defaultIrrigationValues.beginningAvailableWater);
    }

    if (this.currentSoilWaterFillLevel === '' || this.currentSoilWaterFillLevel === null) {
      this.setCurrentSoilWaterFillLevel(this.defaultIrrigationValues.RAWRefillLevel);
    }

    if (this.currentSoilWaterDepletionLevel === '' || this.currentSoilWaterDepletionLevel === null) {
      this.setCurrentSoilWaterDepletionLevel(this.defaultIrrigationValues.RAWDepletionLevel);
    }
    this.availableVolume = this.currentAvailableVolume;
    this.irrigationWaterCost = this.currentIrrigationWaterCost;
    this.maximumIrrigation = this.currentMaximumIrrigation;
    this.minimumIrrigation = this.currentMinimumIrrigation;
    this.maximumIrrigationDose = this.currentMaximumIrrigationDose;
    this.minimumIrrigationDose = this.currentMinimumIrrigationDose;
    this.efficiency = this.currentEfficiency;
    this.suboptimizationModel = this.currentSuboptimizationModel;
    this.numberOfPointsInTheFunction = this.currentNumberOfPointsInTheFunction;
    this.initialSoilMoisture = this.currentInitialSoilMoisture;
    this.soilWaterFillLevel = this.currentSoilWaterFillLevel;
    this.soilWaterDepletionLevel = this.currentSoilWaterDepletionLevel;
  },
  methods: {
    availableVolumeValueChanged(e) {
      this.availableVolume = e.value;
      this.setCurrentAvailableVolume(this.availableVolume);
    },

    irrigationWaterCostValueChanged(e) {
      this.irrigationWaterCost = e.value;
      this.setCurrentIrrigationWaterCost(this.irrigationWaterCost);
    },

    maximumIrrigationValueChanged(e) {
      this.maximumIrrigation = e.value;
      this.setCurrentMaximumIrrigation(this.maximumIrrigation);
    },

    minimumIrrigationValueChanged(e) {
      this.minimumIrrigation = e.value;
      this.setCurrentMinimumIrrigation(this.minimumIrrigation);
    },

    maximumIrrigationDoseValueChanged(e) {
      this.maximumIrrigationDose = e.value;
      this.setCurrentMaximumIrrigationDose(this.maximumIrrigationDose);
    },

    minimumIrrigationDoseValueChanged(e) {
      this.minimumIrrigationDose = e.value;
      this.setCurrentMinimumIrrigationDose(this.minimumIrrigationDose);
    },

    efficiencyValueChanged(e) {
      this.efficiency = e.value;
      this.setCurrentEfficiency(this.efficiency);
    },

    suboptimizationModelValueChanged(e) {
      this.suboptimizationModel = e.value;
      this.setCurrentSuboptimizationModel(this.suboptimizationModel);
    },

    numberOfPointsInTheFunctionValueChanged(e) {
      this.numberOfPointsInTheFunction = e.value;
      this.setCurrentNumberOfPointsInTheFunction(this.numberOfPointsInTheFunction);
    },

    initialSoilMoistureValueChanged(e) {
      this.initialSoilMoisture = e.value;
      this.setCurrentInitialSoilMoisture(this.initialSoilMoisture);
    },

    soilWaterFillLevelValueChanged(e) {
      this.soilWaterFillLevel = e.value;
      this.setCurrentSoilWaterFillLevel(this.soilWaterFillLevel);
    },

    soilWaterDepletionLevelValueChanged(e) {
      this.soilWaterDepletionLevel = e.value;
      this.setCurrentSoilWaterDepletionLevel(this.soilWaterDepletionLevel);
    },
    ...mapActions('Mopeco', ['setCurrentAvailableVolume', 'setCurrentIrrigationWaterCost', 'setCurrentMaximumIrrigation', 'setCurrentMinimumIrrigation', 'setCurrentMaximumIrrigationDose',
      'setCurrentMinimumIrrigationDose', 'setCurrentEfficiency', 'setCurrentSuboptimizationModel', 'setCurrentNumberOfPointsInTheFunction',
      'setCurrentInitialSoilMoisture', 'setCurrentSoilWaterFillLevel', 'setCurrentSoilWaterDepletionLevel']),
  },
};
</script>

<style>
input {
  font-size: inherit !important;
}
.icon-info-right {
  margin-left: 200px;
}
.element-width-min-width {
  min-width: 155%;
}
.element-min-width {
  min-width: 155%;
  padding-right: 100px;
}
</style>
